import React from "react";
import { Formik, Form } from "formik";
import { connect } from "react-redux";
import { string, object } from "yup";
import logo from "url:../../assets/images/lumen-logo.svg";

import { userOperations } from "../MyDetails/duck/index";
import { withRouter } from "react-router-dom";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { theme } from "../CreateStudyPage/MaterialStyling";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";

export class Login extends React.Component {
  constructor() {
    super();
    this.state = {
      showPassword: false,
    };
  }
  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  render() {
    return (
      <Formik
        initialValues={{
          username: "",
          password: "",
          invalidCredentials: false,
        }}
        validationSchema={object().shape({
          username: string().required("Required"),
          password: string().required("Required"),
        })}
        onSubmit={async (values, actions) => {
          actions.setFieldValue("invalidCredentials", false);
          await this.props.login(
            values.username,
            values.password,
            this.props.history
          );

          if (!this.props.authenticated) {
            actions.setFieldValue("invalidCredentials", true);
            actions.setSubmitting(false);
          } else {
            actions.setSubmitting(false);
          }
        }}
      >
        {({
          handleSubmit,
          isSubmitting,
          handleChange,
          errors,
          touched,
          values,
        }) => (
          <Container component="main" style={{ maxWidth: 480 }}>
            <StyledEngineProvider injectFirst>
              <ThemeProvider theme={theme}>
                <Paper
                  elevation={2}
                  style={{
                    padding: "80px 48px",
                    background: "white",
                    marginTop: "8vh",
                  }}
                >
                  <Form onSubmit={handleSubmit}>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <div style={{ width: "60%", margin: " 8px auto 8px" }}>
                          <img src={logo} alt="logo" />
                        </div>
                      </Grid>

                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          id="username"
                          name="username"
                          label="Username"
                          value={values.username}
                          onChange={handleChange}
                          error={touched.username && Boolean(errors.username)}
                          helperText={touched.username && errors.username}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel htmlFor="outlined-adornment-password">
                            Password
                          </InputLabel>
                          <OutlinedInput
                            id="outlined-adornment-password"
                            type={this.state.showPassword ? "text" : "password"}
                            value={values.password}
                            onChange={handleChange}
                            name="password"
                            error={touched.password && Boolean(errors.password)}
                            helperText={touched.password && errors.password}
                            variant="outlined"
                            autoComplete="current-password"
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={this.handleClickShowPassword}
                                  onMouseDown={this.handleMouseDownPassword}
                                  edge="end"
                                  size="large"
                                >
                                  {this.state.showPassword ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            }
                            labelWidth={70}
                          />
                        </FormControl>
                      </Grid>
                      {/* <Grid item xs={12}>
                        <FormControlLabel
                          control={
                            <Checkbox value="allowExtraEmails" color="primary" />
                          }
                          label="Remember me"
                        />
                      </Grid> */}

                      <Grid style={{ marginTop: 4 }} item xs={12}>
                        {values.invalidCredentials ? (
                          <div style={{ position: "relative" }}>
                            <Typography
                              component={"span"}
                              style={{
                                marginLeft: 1,
                                position: "absolute",
                                bottom: 4,
                              }}
                              variant="caption"
                              color="error"
                            >
                              Invalid username or password
                            </Typography>
                          </div>
                        ) : (
                          ""
                        )}
                        <Button
                          startIcon={
                            isSubmitting ? (
                              <CircularProgress
                                style={{ color: "#2962ff" }}
                                size="1rem"
                              />
                            ) : null
                          }
                          type="submit"
                          fullWidth
                          variant="contained"
                          color="primary"
                          disabled={isSubmitting}
                        >
                          Sign In
                        </Button>
                      </Grid>
                    </Grid>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: 15,
                        padding: 1,
                        width: "100%",
                      }}
                    >
                      <Link href="/forgot_password" variant="body2">
                        {/* Forgot password? */}
                      </Link>
                      </div>
                      <div
                      style={{
                      display: "flex",
                      justifyContent: "center",
                       marginTop: 8,
                       }}
                        >
                     <Link href="/request_login" variant="body2">
                      Don't have an account? Sign up
                     </Link>
                      </div>
                  </Form>
                  {/* <FootNote
                    route="/forgot_password"
                    copy="I forgot my password"
                  />
                  <FootNote route="/contact_us" copy="Request login" /> */}
                </Paper>
              </ThemeProvider>
            </StyledEngineProvider>
          </Container>
        )}
      </Formik>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    errorMessage: state.userData.error,
    authenticated: state.userData.authenticated,
  };
};
const mapDispatchToProps = (dispatch) => ({
  login: (username, password, history) =>
    dispatch(userOperations.loginAttempt(username, password, history)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));
